import { useState } from 'react';
import { Navbar, Center, Tooltip, UnstyledButton, createStyles, Stack, Title, Text } from '@mantine/core';
import { Link } from "@tanstack/react-location";
import {
  IconCalendarEvent,
  IconTrademark,
  IconCertificate,
  IconUsers,
  IconSettings,
  IconLogout,
  IconChartDots,
} from '@tabler/icons';

const useStyles = createStyles((theme) => ({
  link: {
    width: 50,
    height: 50,
    borderRadius: theme.radius.md,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[7],

    '&:hover': {
      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
    },
  },

  active: {
    '&, &:hover': {
      backgroundColor: theme.fn.variant({ variant: 'light', color: theme.primaryColor }).background,
      color: theme.fn.variant({ variant: 'light', color: theme.primaryColor }).color,
    },
  },
}));

interface NavbarLinkProps {
  icon: JSX.Element;
  label: string;
  active?: boolean;
  path: string;
  onClick?(): void;
}

function NavbarLink({ icon, label, active, path, onClick }: NavbarLinkProps) {
  const { classes, cx } = useStyles();
  return (
    <Tooltip label={label} position="right" transitionDuration={0}>
      <Link to={path}>
        <UnstyledButton onClick={onClick} className={cx(classes.link, { [classes.active]: active })}>
            {icon}
        </UnstyledButton>
      </Link>
    </Tooltip>
  );
}

const mockdata = [
  { icon: <IconTrademark stroke={1.5} />,        label: "Trademarks",    path: "/trademarks" },
  { icon: <IconCertificate stroke={1.5} />,      label: "Patents",       path: "/patents" },
  { icon: <><IconCalendarEvent stroke={1.5} /><IconTrademark stroke={1.5} /></>,                  label: "Trademark Docket",     path: "/trademarkDocket" },
  { icon: <><IconCalendarEvent stroke={1.5} /><IconCertificate size="20px" stroke={1.5} /></>,    label: "Patent Docket",        path: "/patentDocket" },
  { icon: <IconUsers stroke={1.5} />,            label: "Clients",       path: "/clients" },
  { icon: <IconChartDots stroke={1.5} />,            label: "Statistics",    path: "/statistics" },
  { icon: <IconSettings stroke={1.5} />,         label: 'Settings',      path: "/settings" },
];

export interface IAppNavbarProps {
    onLogout(): void;
}

export default function AppNavbar(props: IAppNavbarProps) {
  const [active, setActive] = useState(0);

  const links = mockdata.map((link, index) => (
    <NavbarLink
      {...link}
      key={link.label}
      active={index === active}
      path={link.path}
      onClick={() => { setActive(index); }}
    />
  ));

  return (
    <Navbar height={"100%"} width={{ base: 80 }} p="md">
      <Title><Center><Text color="red">æ</Text></Center></Title>
      <Navbar.Section grow mt={20}>
        <Stack justify="center" spacing={0}>
          {links}
        </Stack>
      </Navbar.Section>
      <Navbar.Section>
        <Stack justify="center" spacing={0} mb={50}>
          <NavbarLink icon={<IconLogout stroke={1.5} />} label="Logout" path="/" onClick={props.onLogout} />
        </Stack>
      </Navbar.Section>
    </Navbar>
  );
}